<template>
    <div v-if="authManager.isLoggedIn && authManager.metadata?.smsVerificationRequired === true" class="alert alert-warning d-flex flex-wrap align-items-center gap-2" role="status">
        <span class="flex-grow-1">Verify your phone to enable SMS sending for your account.</span>
        <b-button variant="primary" size="sm" @click="$emit('verify')">Verify Phone</b-button>
    </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import type AuthManager from "@/AuthManager";
const authManager = inject<AuthManager>("authManager")!;
defineEmits<{ verify: [] }>();
</script>
